import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { upDataRole } from '../static/js/util'
import qs from 'qs'
import '../static/js/flexible'
import publicJS from '../static/js/public.js'

Vue.use(publicJS)
axios.defaults.timeout = 50000;
Vue.prototype.$axios = axios    
Vue.prototype.$qs = qs
Vue.config.productionTip = false
Vue.prototype.resetSetItem = function (key, newVal) {
    if (key === 'Nav') {
      // 创建一个StorageEvent事件
      var newStorageEvent = document.createEvent('StorageEvent');
      const storage = {
        setItem: function (k, val) {
          sessionStorage.setItem(k, val);
          // 初始化创建的事件
          newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
          // 派发对象
          window.dispatchEvent(newStorageEvent)
        }
      }
      return storage.setItem(key, newVal);
    }
  }
const vue = new Vue({
    router,
    store,
    render: h => h(App),
    beforeCreate(){
        Vue.prototype.$bus  = this  
        // 往Vue的原型上放一个 全局事件总线 $bus（可以任意命名，但是约定俗成用$bus），
        // 在子组件VueComponent中就能调用到这个原型里的东西，因为子组件原型会往Vue的原型上面找
      }
}).$mount('#app')
function reurl(){
    let url = null
    if(location.href.indexOf('login') !=-1){
        url=  location.href; //把当前页面的地址赋给变量 url
        var times = url.split("?"); //分切变量 url 分隔符号为 "?"
        if(times[1] != 1){ //如果?后的值不等于1表示没有刷新
        url += "?1"; //把变量 url 的值加入 ?1
         self.location.replace(url); //刷新页面
        }
    }
    }
window.addEventListener('message',(e)=> {
    console.log('66666666666',e)
    console.log(e.data,232323232);
    console.log(e.data.uid,232323232);
if(e.data.type == "view"){
    // 第一次登录 
    reurl()
    if(!sessionStorage.getItem('h5LoginData')){
        sessionStorage.setItem('h5LoginData',JSON.stringify(e.data))
    }else{
        sessionStorage.setItem('h5LoginData',JSON.stringify(e.data))
    }
    // 跳过了登录，再次存储h5LoginData
}else if(e.data.type == "isLogout"){
    if(!sessionStorage.getItem('h5LoginData')){
        sessionStorage.setItem('h5LoginData',JSON.stringify(e.data.info))
    }else{
        sessionStorage.clear()
        sessionStorage.setItem('h5LoginData',JSON.stringify(e.data.info))
    }
}else if(e.data.type == "overLogin"){
    console.log('over_login过来了');
    if(!sessionStorage.getItem('h5LoginData')){
    sessionStorage.setItem('h5LoginData',JSON.stringify(e.data.info))
}else{
    sessionStorage.setItem('h5LoginData',JSON.stringify(e.data.info))
}      
}else if(e.data.type == "pay"){
    console.log(e.data,33);
    console.log('openPay过来了',JSON.stringify(e.data.info));
    sessionStorage.setItem('payInfo',JSON.stringify(e.data.info))
}else if(e.data.type == "role"){
    console.log(e.data,33);
    console.log('role过来了');
    upDataRole(e.data.info)
    // sessionStorage.setItem('payInfo',JSON.stringify(e.data.info))
}else if(e.data.type == "userData"){
    console.log(565656565,'userData过来了',e.data);
    let data = e.data.info.data
    let options ={ appid:e.data.appid,appkey:e.data.appkey }
        console.log(data,5858858,e.data.info.data);
        sessionStorage.setItem('userData', JSON.stringify({data,...options}))  
}else if(e.data.type == "toLogout"){
    console.log('toLogout过来了',e.data);
    if(e.data.info){
        sessionStorage.clear()
    }
}else if(e.data.type == "nav"){
    store.commit('setNav',e.data.info)
    Vue.prototype.resetSetItem('Nav', e.data.info);
}
    window.removeEventListener("message", () => {});//移除message监听事件，否则会成死循环；
})

// if(e.data.type == "view"){
//     if(e.data.isH5){
//         sessionStorage.setItem('h5LoginData',JSON.stringify(e.data))
//     }
// }else if(e.data.type == "role"){
//     sessionStorage.setItem('roleInfo',JSON.stringify(e.data.info))
// }else if(e.data.type == "pay"){
//     sessionStorage.setItem('payInfo',JSON.stringify(e.data.info))
// }

export default  vue
